export const datHangNcc = {
  sections: {
    list: { title: 'Supplier purchase orders' },
    detail: { title: 'PO detail' },
  },
  titles: { add: 'Create PO' },
  columns: {
    code: 'Code',
    summary: 'Summary',
    status: 'Status',
    ngayTao: 'Created at',
    ngayCapNhat: 'Updated at',
    nhaCungCap: 'Supplier',
    ngayDat: 'Order date',
    ngayNhapDuKien: 'Expected date',
    tongTienHang: 'Subtotal',
    maPhieuNhapKho: 'Stock-in voucher',
  },
  filter: { searchPlaceholder: 'Search...' },
  filters: { hintSection: 'Tips', hintBody: 'Use search.' },
  status: {
    phieuTam: 'Draft voucher',
    daXacNhanNCC: 'Confirmed by supplier',
    nhapMotPhan: 'Partially received',
    hoanThanh: 'Completed',
    daHuy: 'Cancelled',
  },
  form: {
    supplier: 'Supplier',
    code: 'PO code',
    codeAuto: 'Leave blank for auto',
    orderDate: 'Order date',
    expectedDate: 'Expected date',
    trangThai: 'Status',
    phiVanChuyen: 'Shipping fee',
    tienNCCTraLai: 'Supplier refund',
    giamGiaPhieu: 'Order discount',
    giamGiaPhanTram: 'Disc (%)',
    giamGiaHieuLuc: 'Applied discount',
    note: 'Note',
    lines: 'Ordered items',
    addLine: 'Add line',
    product: 'Product',
    productName: 'Product name',
    productSearch: 'Search code / name',
    qty: 'Qty',
    unitPrice: 'Unit price',
    discount: 'Discount',
    discountPercent: 'Disc (%)',
    editDiscount: 'Discount settings',
    byAmount: 'By amount',
    byPercent: 'By percent',
    currency: '₫',
    lineNote: 'Line note',
    lineAmount: 'Amount',
    tongTienHang: 'Subtotal',
    tienTraNcc: 'Paid to supplier',
    canTraNCC: 'Owing',
    datHangNhap: 'Place order',
    thanhToan: 'Payment',
    phuongThucThanhToan: 'Payment method',
    tienMat: 'Cash',
    the: 'Card',
    chuyenKhoan: 'Transfer',
    xong: 'Done',
    titleTienTraNcc: 'Money returned to supplier',
  },
  fields: {
    totalAmount: 'Total amount',
  },
  validation: {
    supplierRequired: 'Please select a supplier',
    soLuongInvalid: 'Line {row} ({name}): quantity must be greater than 0',
    donGiaInvalid: 'Line {row} ({name}): unit price cannot be negative',
    expectedBeforeOrder: 'Expected receipt date cannot be before the order date',
  },
  messages: {
    loadError: 'Could not load list.',
    deleteSuccess: 'Deleted.',
    noData: 'No records.',
    noLines: 'No order lines.',
    listSummary: 'Total {count}',
    createSuccess: 'Purchase order created.',
    updateSuccess: 'Purchase order updated.',
    needLines: 'Please add at least one line.',
    confirmDelete: 'Delete voucher {name}?',
    copySuccess: 'Purchase order copied.',
    completeSuccess: 'Purchase order completed.',
    cancelSuccess: 'Purchase order cancelled.',
    importSuccess: 'Items imported successfully.',
  },
  detailTabs: {
    generalInfo: 'General info',
  },
  placeholders: {
    formTitle: 'Create / edit PO',
    formBody: 'Full forms will be added later.',
  },
  actions: {
    createPhieuNhan: 'Create Receipt',
    copy: 'Copy',
    complete: 'Complete',
    cancelVoucher: 'Cancel voucher',
    importExcel: 'Import Excel',
    downloadTemplate: 'Download template',
  },
  emptyState: {
    title: 'Add products from Excel file',
    downloadTemplate: '(Download template: PO import file)',
    chooseFile: 'Choose data file',
    hint: 'Columns: Item code, Product name, Unit, Unit price, Discount, Quantity. Item codes must match codes saved in the system.',
    noSheet: 'File has no data sheet.',
    noData: 'No valid rows found.',
    importPartial: 'Imported {success}/{total} rows.',
    someUnmatched: '{count} row(s) had no matching item code.',
    allUnmatched: 'No rows matched (out of {total}).',
  },
  aria: {
    columnPicker: 'Choose visible columns',
  },
}
